export default {
  data: null,
  filters: [],
  stories: null,
  error: null,
  loading: false,
  counter: null,
  updateCountersStatus: null
}
